import { render, staticRenderFns } from "./RemissaoContainer.vue?vue&type=template&id=666c0545&scoped=true"
import script from "./RemissaoContainer.vue?vue&type=script&lang=js"
export * from "./RemissaoContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666c0545",
  null
  
)

export default component.exports